import { BookingDB, LightObject, LightModel } from "./BookingLightDB"
import { computed } from "mobx"
import { SquareLineItem } from "light/light-square"
import { uuid } from "../../light/utils"

export interface $LineItem extends LightObject {
  note: string
  quantity: number
  fullName: string
  passNumber: string | null
  sessionTypeName: string
  sessionTime: string
  priceInCents: number
  catalogObjectId: string
  catalogObjectIdTax: string
}

export class LineItem implements LightModel {
  constructor(db: BookingDB, object?: $LineItem) {
    this.db = db
    this.object = object ? object : LineItem.create$Object()
  }

  static create$Object(): $LineItem {
    return {
      $id: uuid(),
      $type: "booking",
      $version: uuid(),
      $parentVersion: null,
      $versionDateString: new Date().toISOString(),
      note: "",
      fullName: "",
      passNumber: "",
      sessionTypeName: "",
      sessionTime: "",
      quantity: 0,
      priceInCents: 0,
      catalogObjectId: "",
      catalogObjectIdTax: "73I7KUDI3GYL4SIA3ICB67JP"
    }
  }

  db: BookingDB

  object: $LineItem

  @computed
  get id() {
    return this.object.$id
  }

  @computed
  get type() {
    return this.object.$type
  }

  children = null
  isValid = true
  invalidMessage = undefined
  clean() {}

  @computed
  get totalInCents() {
    return this.object.quantity * this.object.priceInCents
  }

  @computed
  get totalFriendly() {
    return (this.totalInCents / 100).toFixed(2)
  }

  @computed
  get toSquare(): SquareLineItem {
    return {
      quantity: String(this.object.quantity),
      catalog_object_id: this.object.catalogObjectId,
      taxes: [{ catalog_object_id: this.object.catalogObjectIdTax }],
      note: this.object.note
    }
  }
}
